import React, { Component } from 'react'
import styles from './SingleSong.module.css'
import Modal from 'react-modal'
import CrossSVG from '../../../../SVG/CrossSVG'

class SingleSong extends Component {
  constructor() {
    super()

    this.state = {
      modalIsOpen: false,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  renderPoster = () => {
    const { poster, title } = this.props.node.acf

    const image = <img src={poster.source_url} alt={title} />

    return image
  }

  openModal() {
    const { is_active } = this.props.node.acf

    if (is_active === true) {
      this.setState({ modalIsOpen: true })
    }
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  getStyles = () => {
    const { is_active } = this.props.node.acf
    if (is_active === true) {
      return styles.SingleSong
    } else {
      return styles.SingleSongDisabled
    }
  }

  render() {
    const { popup_content } = this.props.node.acf
    const { video_link, film_maker_statement, stills, lyrics } = popup_content
    const wrapperStyles = this.getStyles()

    return (
      <div className={wrapperStyles} onClick={this.openModal}>
        {this.renderPoster()}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          className={styles.modal}
          overlayClassName={styles.overlay}
        >
          <div className={styles.closeIcon} onClick={this.closeModal}>
            <CrossSVG />
          </div>
          {video_link.length > 0 ? (
            <div className={styles.embedContainer}>
              <iframe src={video_link} frameborder="0" allowfullscreen />
            </div>
          ) : null}

          {film_maker_statement.length > 0 ? (
            <div className={styles.statement}>
              <div
                dangerouslySetInnerHTML={{
                  __html: film_maker_statement,
                }}
              />
            </div>
          ) : null}

          {stills ? (
            <div className={styles.stills}>
              {stills.map(still => {
                return <img src={still.source_url} alt="Still" />
              })}
            </div>
          ) : null}

          {lyrics.length > 0 ? (
            <div className={styles.statement}>
              <div
                dangerouslySetInnerHTML={{
                  __html: lyrics,
                }}
              />
            </div>
          ) : null}
        </Modal>
      </div>
    )
  }
}

export default SingleSong



// WEBPACK FOOTER //
// ./src/components/EightRooms/SongList/SingleSong/SingleSong.js